import React, { useEffect, useState } from 'react';
import ImageUpload from '../ImageUpload/ImageUpload.js';
import ConfirmationDialog from '../ConfirmationDialog.js';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {
  addHomeSlide,
  clearData,
  editHomeSlide,
  resetSelectedHomeSlideRow,
} from '../../../Redux/HomeSlideRedux.js';

const AddHomeSlide = ({ setShowForm }) => {
  const { selectedHomeSlideRow } = useSelector((state) => state.homeSlideRedux);
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [clearImages, setClearImages] = useState(false);
  const [imageItems, setImageItems] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [homeSlideData, setHomeSlideData] = useState({
    title: '',
    description: '',
  });

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (selectedHomeSlideRow && Object.keys(selectedHomeSlideRow).length > 0) {
      setHomeSlideData({
        title: selectedHomeSlideRow.title || '',
        description: selectedHomeSlideRow.description || '',
      });
      const exist = Array.isArray(selectedHomeSlideRow.images)
        ? selectedHomeSlideRow.images.map((img) =>
            typeof img === 'string' ? img : img.image
          )
        : [];
      setExistingImages(exist);
      setIsEditing(true);
    } else resetForm();
  }, [selectedHomeSlideRow]);

  const handleImageChange = (items) => {
    setImageItems(items);
    const newFiles = items
      .filter((it) => it.file instanceof File)
      .map((it) => it.file);
    const existing = items
      .filter((it) => !(it.file instanceof File))
      .map((it) => it.image);
    setUploadedFiles(newFiles);
    setExistingImages(existing);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHomeSlideData((prev) => ({ ...prev, [name]: value }));
  };

  const editHomeSlideConfirm = () => {
    const slideId = selectedHomeSlideRow.id;
    const adminId = user.userId;
    if (
      (!uploadedFiles.length && !existingImages.length) ||
      !homeSlideData.title.trim() ||
      !homeSlideData.description.trim()
    ) {
      toast.error(
        'Please fill all required fields and upload at least one image'
      );
      return;
    }
    const formData = new FormData();
    formData.append('title', homeSlideData.title);
    formData.append('description', homeSlideData.description);
    if (existingImages.length > 0) {
      formData.append('existingImages', JSON.stringify(existingImages));
    }
    if (uploadedFiles.length > 0) {
      uploadedFiles.forEach((file) => formData.append('images', file));
    }
    dispatch(editHomeSlide(adminId, formData, slideId))
      .then(() => {
        resetForm();
        setShowForm(false);
        setClearImages(true);
        dispatch(clearData());
      })
      .catch((error) => console.error('Error:', error));
  };

  const handleClose = () => {
    resetForm();
    setShowForm(false);
    setConfirmDialog(false);
    dispatch(resetSelectedHomeSlideRow());
  };

  const handleConfirmClose = () => setConfirmDialog(false);

  const handleHomeSlideSubmit = (e) => {
    e.preventDefault();
    if (
      (!uploadedFiles.length && !existingImages.length) ||
      !homeSlideData.title.trim() ||
      !homeSlideData.description.trim()
    ) {
      toast.error('Please fill all required fields and upload an image');
      return;
    }
    const formData = new FormData();
    uploadedFiles.forEach((file) => formData.append('images', file));
    formData.append('existingImages', JSON.stringify(existingImages));
    formData.append('title', homeSlideData.title);
    formData.append('description', homeSlideData.description);
    const adminId = user.userId;
    if (isEditing) {
      setConfirmDialog(true);
    } else {
      dispatch(addHomeSlide(adminId, formData))
        .then(() => {
          resetForm();
          setShowForm(false);
          setImageItems([]);
          setUploadedFiles([]);
          setExistingImages([]);
          setClearImages(true);
          setTimeout(() => setClearImages(false), 0);
        })
        .catch((error) => console.error('Error in adding slide:', error));
    }
  };

  const resetForm = () => {
    setHomeSlideData({ title: '', description: '' });
    setIsEditing(false);
    setImageItems([]);
    setUploadedFiles([]);
    setExistingImages([]);
    setClearImages(true);
    setTimeout(() => setClearImages(false), 0);
  };

  return (
    <>
      <div className='m-3'>
        <h5>{isEditing ? 'Edit Home Slide' : 'Add Home Slide'}</h5>
        <div style={{ padding: '25px' }}>
          <form>
            <div className='row'>
              <div className='col-12'>
                <label>
                  Image<span style={{ color: 'red' }}>*</span>
                </label>
                <ImageUpload
                  onImagesChange={handleImageChange}
                  clearImages={clearImages}
                  isEditing={isEditing}
                  allowMultiple={false}
                  currentImages={selectedHomeSlideRow?.images || []}
                />
              </div>
            </div>
            <div className='row mt-3'>
              <div className='col-12'>
                <label>Title</label>
                <input
                  type='text'
                  value={homeSlideData.title}
                  onChange={handleChange}
                  name='title'
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <label>Description</label>
                <div className='form-floating'>
                  <textarea
                    required
                    className='form-control mb-3'
                    name='description'
                    value={homeSlideData.description}
                    onChange={handleChange}
                    style={{ height: '100px' }}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='d-grid gap-2 col-6 mx-auto'>
                <button
                  className='btn'
                  style={{ background: '#2b6930', color: '#fff' }}
                  onClick={handleHomeSlideSubmit}
                >
                  Submit
                </button>
              </div>
              <div className='d-grid gap-2 col-6 mx-auto'>
                <button
                  type='button'
                  className='btn'
                  style={{ background: '#C0000B', color: '#fff' }}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleConfirmClose}
        onConfirm={editHomeSlideConfirm}
        description='Are you sure you want to save?'
      />
    </>
  );
};

export default AddHomeSlide;
